<template>
  <div class="field-container">
    <!-- <label :for="id" class="form-label">{{ $t(`forms.${label}`) }} {{ showAsterisk }}</label> -->

    <div class="row">
      <input
        v-cypress="testId"
        :type="type"
        :disabled="disabled"
        :id="id"
        class="form-input"
        :class="{ isValid: !isValid }"
        v-validate="this.validate !== '' ? this.validate : false"
        v-bind:value="value"
        :ref="id"
        :name="id"
        :placeholder="$t(`forms.${label}`)"
        @input="$emit('input', $event.target.value)"
      />

      <!-- <div class="valid-field">
        <img v-if="isValid" src="@/assets/input-valid-check-mark.png" />
      </div> -->
    </div>
    <!-- <span class="form-error">{{ errors.first(id) }}</span> -->
  </div>
</template>

<script>
export default {
  name: 'VvFormTextInput',
  computed: {
    showAsterisk() {
      if (this.validate) {
        if (
          typeof this.validate == 'object' &&
          'required' in this.validate &&
          this.validate.required == true
        )
          return '*'
        else if (typeof this.validate == 'string' && this.validate.indexOf('required') !== -1)
          return '*'
      }

      return ''
    },
    formErrors: function() {
      return this.$validator.errors
    }
  },
  data: () => ({
    isValid: true
  }),
  props: {
    id: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: ''
    },
    validate: [String, Object],
    disabled: {
      type: Boolean,
      default: false
    },
    testId: {
      type: String,
      default: null
    },
    isRegister: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  inject: ['$validator'],
  watch: {
    value: async function(val) {
      if (this.validate === '') {
        this.isValid = val !== ''
      } else {
        this.isValid = (await this.$validator.verify(val, this.validate)).valid
      }
    },
    formErrors: {
      handler: function(value) {
        if (!!this.$validator.errors.first(this.id) == false) {
          this.isValid = true
        } else {
          this.isValid = false
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.form-input {
  height: 25px;
  border-radius: 7px;
  background-color: rgba(255, 255, 255, 1);
  opacity: 1;
  padding: 9px 13px;
  margin: 5px;
  font-size: 16px;
  font-weight: 500;
  font-family: $font-family-splash;
  width: 100%;
  color: $font-color;
  border: none;
}
.form-input:focus {
  outline: solid 2px $primary;
}

.form-label {
  text-align: left;
  margin-bottom: 6px;
}

.valid-field {
  float: right;
  height: 14px;
  object-fit: contain;
  padding: 10px 10px 10px 10px;
}

.row {
  display: flex;
  justify-content: space-between;
}

.field-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.form-error {
  display: block;
  color: red;
  margin-top: 4px;
  font-size: 10px;
  font-weight: 500;
  text-align: left;
}

.password {
  color: #2d2d2d;
}

.isValid {
  outline: solid 1px red;
}

@media all and (max-width: 620px){

  form-input {
  height: 20px;
  border-radius: 7px;
  background-color: rgb(73, 15, 15);
  opacity: 1;
  padding: 9px 13px;
  margin: 15px;
  font-size: 12px;
  font-weight: 900;
  font-family: $font-family-splash;
  // width: 20%;
  color: $font-color;
  border: none;
}

.field-container {
  display: flex;
  flex-direction: column;
  width: 70%;
}
}
</style>
